import React from "react";
import trophyGold from "Assets/badging/Trophy_Gold.svg"
import trophySilver from "Assets/badging/Trophy_Silver.svg"

export default function TrophyCell(props) {
  const {value, isNew=false} = props;

  if (!value) return null;

  let str = value;
  let src = trophyGold;

  if (isNew) {
    str = `+${str}`
    src = trophySilver;
  }

  return (
      <div className="trophyImgWrap">
        <img className="trophyImg" src={src} alt="trophy"/>
        <div className="trophyValue">{str}</div>
      </div>
  )
}